module.exports = __webpack_public_path__ + "public/Icons/clockDark.svg?4beab287";